export default "__VITE_ASSET__DRF5Hb2y__"